import React from "react";
import { motion } from "framer-motion";

export default function Hero({ onCTAClick }){
  return (
    <section className="py-16" id="home">
      <div className="grid md:grid-cols-2 gap-8 items-center max-w-6xl mx-auto">
        <motion.div initial={{opacity:0, x:-20}} animate={{opacity:1, x:0}} transition={{duration:0.6}}>
          <h1 className="text-4xl sm:text-5xl font-extrabold leading-tight">Help build the perfect student budgeting app 🚀</h1>
          <p className="mt-4 text-gray-600 dark:text-gray-300 text-lg max-w-xl">
            FinBit automatically tracks expenses from SMS, nudges you before overspending, and gives AI-backed saving suggestions — made for college life.
          </p>

          <div className="mt-6 flex flex-wrap gap-3">
            <button onClick={onCTAClick} className="px-6 py-3 rounded-full bg-gradient-to-r from-[#06b6d4] to-[#7c3aed] text-white font-semibold shadow-lg neon-hover neon-focus">
              ✅ Take the Quick Survey
            </button>
            <a href="#how" className="px-5 py-3 rounded-full border border-gray-200 dark:border-gray-700">How it works</a>
          </div>

          <div className="mt-4 text-sm text-gray-500 dark:text-gray-400">
            ⏱ 1–2 minutes • 🎁 Early access + ₹500 voucher draw
          </div>
        </motion.div>

        <motion.div initial={{opacity:0, y:12}} animate={{opacity:1, y:0}} transition={{duration:0.7}} className="flex items-center justify-center">
          <div className="w-full max-w-md p-4 rounded-2xl glass border border-gray-100 dark:border-gray-800 shadow-lg neon-hover">
            <div className="h-64 rounded-lg bg-gradient-to-br from-[#eef2ff] to-[#f0f9ff] dark:from-[#071733] dark:to-[#0a1822] flex items-center justify-center">
              <div className="text-center px-6">
                <div className="text-sm text-gray-600 dark:text-gray-300">Auto-categorized expenses</div>
                <div className="mt-3 text-2xl font-semibold">₹2,350</div>
                <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">spent on food this week</div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
